import { render } from "./Ethiopia.vue?vue&type=template&id=454c41dc"
import script from "./Ethiopia.vue?vue&type=script&lang=js"
export * from "./Ethiopia.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__